import React, { lazy, Suspense, useEffect } from 'react';
import { RouteComponentProps, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import devtools from 'devtools-detect';

import LoginRoute from './routes/LoginRoute';
import PrivateRoute from './routes/PrivateRoute';
import LogoutRoute from './routes/LogoutRoute';
import { useUser } from './store/hooks/hooks';
import Header from './components/Header';
import NotificationBar from './components/NotificationBar';
import LuotVanHanhThongBao from './components/LuotVanHanhThongBao';
import CheckinCheckout from './components/CheckinCheckout';
import SelectedChat from './components/SelectedChat';
import CONSTANTS from './constants/constant';

import './DesktopApp.scss';

const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const Home = lazy(() => import('./pages/Home'));
const UserProfile = lazy(() => import('./pages/UserProfile'));
const TaiXe = lazy(() => import('./pages/drivers/TaiXe'));
// Menu QUẢN LÝ XE — bản viết lại theo app desktop (pages/quan-ly-xe).
const QuanLyXe = lazy(() => import('./pages/quan-ly-xe/QuanLyXe'));
const Customer = lazy(() => import('./pages/customers/Customer'));
const CustomerAssign = lazy(() => import('./pages/customer-assign/CustomerAssign'));
const PhanViecKhachHang = lazy(() => import('./pages/phan-viec-khach-hang/PhanViecKhachHang'));
const DriverAssign = lazy(() => import('./pages/driver-assign/DriverAssign'));
const PhanViecTaiXe = lazy(() => import('./pages/phan-viec-tai-xe/PhanViecTaiXe'));
const Order = lazy(() => import('./pages/Order'));
const Owner = lazy(() => import('./pages/customers/Owner'));
const Transport = lazy(() => import('./pages/transports/Transport'));
const VanHanhPhongThau = lazy(() => import('./pages/van-hanh-phong-thau/VanHanhPhongThau'));
const KiemSoatDonHang = lazy(() => import('./pages/kiem-soat-don-hang/KiemSoatDonHang'));
const PriceQuote = lazy(() => import('./pages/price-quote/PriceQuote'));
const Payment = lazy(() => import('./pages/payments/Payment'));
const InstantOrderV2 = lazy(() => import('./pages/instants/InstantOrderV2'));
const InstantTest = lazy(() => import('./pages/instants/InstantTest'));
const OwnerTest = lazy(() => import('./pages/customers/OwnerTest'));
const AdminUserWeb = lazy(() => import('./pages/admin-user-web/AdminUserWeb'));
const AdminUserTxe = lazy(() => import('./pages/AdminUserTxe'));
const AdminUserCh = lazy(() => import('./pages/AdminUserCh'));
const Chanh = lazy(() => import('./pages/Chanh'));
const ChanhDatHang = lazy(() => import('./pages/ChanhDatHang'));
const Receipt = lazy(() => import('./pages/Receipt'));
const WorkingTime = lazy(() => import('./pages/WorkingTime'));
const ExecuteThePlan = lazy(() => import('./pages/fault-reports/ExecuteThePlan'));
const AssistanceAndRepair = lazy(() => import('./pages/nganh-hang-phu-tro/AssistanceAndRepair'));
const AdminWorkingTime = lazy(() => import('./pages/AdminWorkingTime'));
const BaoCaoThongKe = lazy(() => import('./pages/report-statistic/BaoCaoThongKe'));
const AppPhones = lazy(() => import('./pages/AppPhones'));
const Support = lazy(() => import('./pages/Support'));
const Privacy = lazy(() => import('./pages/Privacy'));
const ExportImages = lazy(() => import('./pages/drivers/ExportImages'));
const Insurance = lazy(() => import('./pages/Insurance'));
const OwnerInsurance = lazy(() => import('./pages/OwnerInsurance'));
const InsuranceNearingExpiration = lazy(() => import('./pages/InsuranceNearingExpiration'));
const PhapChe = lazy(() => import('./pages/phap-che/PhapChe'));
const Files = lazy(() => import('./pages/files/Files'));
const CallTrackingStatistic = lazy(() => import('./pages/CallTrackingStatistic'));
const ManageInternalChat = lazy(() => import('./pages/manage-chat/ManageInternalChat'));
const OwnerAssignments = lazy(() => import('./pages/owner-assignments/OwnerAssignments'));
const KeToanChi = lazy(() => import('./pages/ke-toan-chi/KeToanChi'));
const KyQuy = lazy(() => import('./pages/ky-quy/KyQuy'));
const KeToanChungTu = lazy(() => import('./pages/hop-dong-kinh-te/KeToanChungTu'));
const ProjectOne = lazy(() => import('./pages/projectone/ProjectOne'));
const CompanyBankGroup = lazy(() => import('./pages/company-banks/CompanyBankGroup'));
const SoDuNganHangGroup = lazy(() => import('./pages/company-banks/SoDuNganHangGroup'));
const PhanViecNhomNganhHang = lazy(() => import('./pages/phan-viec-nhom-nganh/PhanViecNhomNganhHang'));
const LandingPageSetting = lazy(() => import('./pages/landing-page-setting/LandingPageSetting'));
const XeTimHangWrapper = lazy(() => import('./pages/xe-tim-hang/XeTimHangWrapper'));
const TargetDoanhSo = lazy(() => import('./pages/workings/TargetDoanhSo'));
const DanhGiaVicAITab = lazy(() => import('./pages/danh-gia-vic-ai/DanhGiaVicAITab'));
const CaiDatKhaoSat = lazy(() => import('./pages/khao-sat/CaiDatKhaoSat'));
const KhaoSat = lazy(() => import('./pages/khao-sat/KhaoSat'));
const LichLamViec = lazy(() => import('./pages/working-times/LichLamViec'));
const CaiDatPhanQuyen = lazy(() => import('./pages/permission-setting/CaiDatPhanQuyen'));
const XuLyVanBan = lazy(() => import('./pages/xu-ly-van-ban/XuLyVanBan'));
const HanMucCongNo = lazy(() => import('./pages/han-muc-cong-no/HanMucCongNo'));
const SystemHealth = lazy(() => import('./pages/system-health/SystemHealth'));
const AIServer = lazy(() => import('./pages/ai-server/AIServer'));
const LichBot = lazy(() => import('./pages/lich-bot/LichBot'));
const VanPhong3D = lazy(() => import('./pages/van-phong/VanPhong3D'));
const HangMucAI = lazy(() => import('./pages/hang-muc-ai/HangMucAI'));
const ChongSpamOtp = lazy(() => import('./pages/chong-spam-otp/ChongSpamOtp'));

window.addEventListener('orientationchange', function () {
  window.location.reload();
});

export default function DesktopApp() {
  const user = useUser();
  const location = useLocation();

  // const checkServerTime = async () => {
  //   const res = await AccountService.getServerTime();
  //   if (res.success) {
  //     const serverTime = res.data;
  //     if (moment().diff(moment(serverTime), 'seconds') > 5) {
  //       alert(
  //         `THỜI GIAN TRÊN MÁY CỦA BẠN KHÔNG CHÍNH XÁC VỚI SERVER. YÊU CẦU CẬP NHẬT CHÍNH XÁC ${moment(
  //           serverTime,
  //         ).format(CONSTANTS.DATE_FORMAT.LONG)} ĐỂ SỬ DỤNG HỆ THỐNG.`,
  //       );
  //       window.location.href = '/logout';
  //     }
  //   }
  // };

  const renderHome = (props: RouteComponentProps) => {
    return <Home {...props} />;
  };

  const renderUserProfile = (props: RouteComponentProps) => {
    return <UserProfile {...props} />;
  };

  const redirectToPageNotFound = () => {
    return <Redirect to="/" />;
  };

  const renderTaiXePage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_TAI_XE) ? <TaiXe {...props} /> : <Redirect to="/profile" />;
  };

  const renderQuanLyTaiXePage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.QUAN_LY_TAI_XE) ? <QuanLyXe /> : <Redirect to="/profile" />;
  };

  const renderCustomerPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_CHU_HANG) ? (
      <Customer {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderCustomerAssignPage = () => {
    return <CustomerAssign />;
  };

  const renderPhanViecKhachHangPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAN_VIEC_KHACH_HANG) ? (
      <PhanViecKhachHang />
    ) : (
      <Redirect to="/profile" />
    );
  };

  // Trang tài xế CŨ (DriverAssign) — đã chuyển sang /phan-viec-tai-xe-cu (20/10/2026).
  const renderDriverAssignPage = () => {
    return <DriverAssign />;
  };

  // Trang PHÂN VIỆC TÀI XẾ MỚI (bot trợ lý AI) — gác menu web riêng.
  const renderPhanViecTaiXePage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAN_VIEC_TAI_XE_MOI) ? (
      <PhanViecTaiXe />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderManageInternalChatPage = () => {
    return <ManageInternalChat />;
  };

  const renderOrderPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.XE_DAT_HANG) ? <Order {...props} /> : <Redirect to="/profile" />;
  };

  const renderOwnerPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CHU_DAT_HANG) ? <Owner {...props} /> : <Redirect to="/profile" />;
  };

  const renderChanhPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_CHANH) ? <Chanh /> : <Redirect to="/profile" />;
  };

  const renderChanhDatHangPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CHANH_DAT_HANG) ? <ChanhDatHang /> : <Redirect to="/profile" />;
  };

  const renderTransportPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_HANH_DON_HANG) ? (
      <Transport {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderVanHanhPhongThauPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_HANH_DON_HANG_PHONG_THAU) ? (
      <VanHanhPhongThau {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderHanMucCongNoPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HAN_MUC_CONG_NO) ||
      user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DANH_SACH_VAY_TIEN) ? (
      <HanMucCongNo {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderKiemSoatDonHangPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KIEM_SOAT_DON_HANG) ? (
      <KiemSoatDonHang {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderPriceQuote = (props: RouteComponentProps) => {
    return <PriceQuote {...props} />;
  };

  const renderPaymentPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THANH_TOAN_CHUYEN_KHOAN) ? (
      <Payment {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  // const renderInstantOrderPage = (props: RouteComponentProps) => {
  //   return <InstantOrder {...props} />;
  // };

  const renderNewInstantOrderPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH) ? (
      <InstantOrderV2 {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderNewInstantTestPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH_TEST) ? (
      <InstantTest {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderOwnerTestPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH_TEST) ? (
      <OwnerTest {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderXeTimHangPage = (props: RouteComponentProps) => {
    return <XeTimHangWrapper {...props} />;
  };

  // const renderDriverInfoPage = () => {
  //   return <DriverInfo />;
  // };

  const renderReceiptPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HOP_DONG_DON_HANG) ? <Receipt /> : <Redirect to="/profile" />;
  };

  const renderKeToanChungTuPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KE_TOAN_CHUNG_TU) ? (
      <KeToanChungTu {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  const renderAdminUserWebPage = () => {
    return <AdminUserWeb />;
  };

  const renderSoDuNganHangPage = () => {
    return <SoDuNganHangGroup />;
  };

  const renderCompanyBankGroupPage = () => {
    return <CompanyBankGroup />;
  };

  const renderAdminUserTxePage = () => {
    return <AdminUserTxe />;
  };

  const renderAdminUserChPage = () => {
    return <AdminUserCh />;
  };

  const renderWorkingTimePage = () => {
    return <WorkingTime />;
  };

  const renderCaiDatTargetDoanhSoPage = () => {
    return <TargetDoanhSo />;
  };

  const renderExecuteThePlanPage = (props: RouteComponentProps) => {
    return <ExecuteThePlan {...props} />;
  };

  const renderNganhHangPhuTroPage = (props: RouteComponentProps) => {
    return <AssistanceAndRepair {...props} />;
  };

  const renderAdminWorkingTimePage = () => {
    return <AdminWorkingTime />;
  };

  const renderBaoCaoThongKePage = () => {
    return <BaoCaoThongKe />;
  };

  const renderCallTrackingStatisticPage = () => {
    return <CallTrackingStatistic />;
  };

  const renderAppPhonesPage = () => {
    return <AppPhones />;
  };

  const renderSupportPage = () => {
    return <Support />;
  };

  const renderPrivacyPage = () => {
    return <Privacy />;
  };

  const renderInsurancePage = () => {
    return <Insurance />;
  };

  const renderInsuranceNearingExpirationPage = () => {
    return <InsuranceNearingExpiration />;
  };

  const renderPhapChe = () => {
    return <PhapChe />;
  };

  const renderFiles = () => {
    return <Files />;
  };

  const renderOwnerInsurancePage = () => {
    return <OwnerInsurance />;
  };

  const renderKeToanChi = () => {
    return <KeToanChi />;
  };

  const renderOwnerAssignment = () => {
    return <OwnerAssignments />;
  };

  const renderKyQuy = () => {
    return <KyQuy />;
  };

  const renderPhanViecNhomNganhHang = () => {
    return <PhanViecNhomNganhHang />;
  };

  const renderProjectOne = () => {
    return <ProjectOne />;
  };

  const renderLandingPage = () => {
    return <LandingPageSetting />;
  };

  const renderDanhGiaVicAIPage = (props: RouteComponentProps) => {
    return <DanhGiaVicAITab {...props} />;
  };

  const renderCaiDatKhaoSatPage = () => {
    return <CaiDatKhaoSat />;
  };

  const renderKhaoSatPage = () => {
    return <KhaoSat />;
  };

  const renderExportImagesPage = (props: RouteComponentProps) => {
    return <ExportImages {...props} />;
  };

  const renderAdminLoginPage = (props: RouteComponentProps) => {
    return <AdminLogin {...props} />;
  };

  const renderLichLamViecPage = (props: RouteComponentProps) => {
    return <LichLamViec {...props} />;
  };

  const renderCaiDatPhanQuyenPage = (props: RouteComponentProps) => {
    return <CaiDatPhanQuyen {...props} />;
  };

  const renderXuLyVanBanPage = (props: RouteComponentProps) => {
    return <XuLyVanBan {...props} />;
  };

  // Chặn ở tầng route chứ không chỉ ẩn menu — gõ thẳng URL vẫn vào được nếu chỉ ẩn menu.
  const renderSystemHealthPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THEO_DOI_HE_THONG) ? (
      <SystemHealth {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  // Chặn ở tầng route chứ không chỉ ẩn menu — ẩn menu chỉ ngăn người dùng giao diện,
  // gõ thẳng URL vẫn vào được.
  const renderAIServerPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THEO_DOI_AI_SERVER) ? (
      <AIServer {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  // LỊCH BOT CHẠY / VĂN PHÒNG 3D (Kế hoạch 7): gác menu web như AI SERVER — hasVicMenu không bypass quản trị (Q2).
  const renderLichBotPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.LICH_BOT_CHAY) ? <LichBot /> : <Redirect to="/profile" />;
  };
  const renderVanPhongPage = () => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_PHONG_3D) ? <VanPhong3D /> : <Redirect to="/profile" />;
  };

  // Trang HẠNG MỤC AI (nguồn dữ liệu cho API /vicai/de-xuat-hang-muc). Chặn ở tầng route
  // chứ không chỉ ẩn menu — ẩn menu chỉ ngăn người dùng giao diện.
  const renderHangMucAIPage = (props: RouteComponentProps) => {
    return user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HANG_MUC_AI) ? (
      <HangMucAI {...props} />
    ) : (
      <Redirect to="/profile" />
    );
  };

  // Màn điều khiển chống SMS pumping: tắt được attestation, sửa trần chi phí SMS. Chặn ở
  // tầng route chứ không chỉ ẩn menu — ẩn menu chỉ chặn người dùng giao diện.
  const renderChongSpamOtpPage = (props: RouteComponentProps) => {
    return user.isAdmin() ? <ChongSpamOtp {...props} /> : <Redirect to="/profile" />;
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;
    if (user?.id === 62) return;
    const detectDevTool = () => {
      if (devtools.isOpen && window.location.hostname.indexOf('vicvnlogistics.com') !== -1) {
        alert('Vui lòng không mở DevTools khi sử dụng phần mềm');
      }
    };
    window.addEventListener('devtoolschange', (event: any) => {
      console.log('Is DevTools open:', event.detail.isOpen);
      console.log('DevTools orientation:', event.detail.orientation);
      if (event.detail.isOpen && window.location.hostname.indexOf('vicvnlogistics.com') !== -1) {
        alert('Vui lòng không mở DevTools khi sử dụng phần mềm');
      }
    });
    window.addEventListener('load', detectDevTool);
    // window.addEventListener('resize', detectDevTool);
    // window.addEventListener('mousemove', detectDevTool);
    // window.addEventListener('focus', detectDevTool);
    // window.addEventListener('blur', detectDevTool);
  }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     checkServerTime();
  //   }, 10000);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <div className="wrapper">
      {user.isLoggedIn() && !['/support', '/privacy', '/export-images'].includes(location.pathname) && <Header />}
      {/* Thông báo TỚI LƯỢT CHỜ VẬN HÀNH ở mọi trang (tự ẩn khi đang ở /don-hang-nhanh) */}
      {user.isLoggedIn() && !['/support', '/privacy', '/export-images'].includes(location.pathname) && (
        <LuotVanHanhThongBao />
      )}
      {!['/chat', '/support', '/privacy', '/export-images', '/system-health', '/ai-server', '/van-phong'].includes(
        location.pathname,
      ) && <NotificationBar />}
      <div id="content">
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <LoginRoute path="/login" />
            <LogoutRoute path="/logout" />
            <PrivateRoute
              roles={[CONSTANTS.SYSTEM_ROLES.QUAN_TRI_HE_THONG]}
              path="/"
              exact={true}
              render={renderHome}
            />
            <PrivateRoute path="/profile" render={renderUserProfile} />
            <PrivateRoute path="/tai-xe" render={renderTaiXePage} />
            <PrivateRoute path="/quan-ly-tai-xe" render={renderQuanLyTaiXePage} />
            <PrivateRoute path="/xe-dat-hang" render={renderOrderPage} />
            <PrivateRoute path="/chu-hang" render={renderCustomerPage} />
            <PrivateRoute path="/chu-dat-hang" render={renderOwnerPage} />
            <PrivateRoute path="/van-hanh" render={renderTransportPage} />
            <PrivateRoute path="/van-hanh-phong-thau" render={renderVanHanhPhongThauPage} />
            <PrivateRoute path="/han-muc-cong-no" render={renderHanMucCongNoPage} />
            <PrivateRoute path="/kiem-soat-dh" render={renderKiemSoatDonHangPage} />
            <PrivateRoute path="/thanh-toan" render={renderPaymentPage} />
            {/* <PrivateRoute  path="/don-hang-nhanh-v1" render={renderInstantOrderPage} /> */}
            <PrivateRoute path="/don-hang-nhanh" render={renderNewInstantOrderPage} />
            <PrivateRoute path="/don-hang-nhanh-test" render={renderNewInstantTestPage} />
            <PrivateRoute path="/quan-ly-don-test" render={renderOwnerTestPage} />
            <PrivateRoute path="/xe-tim-hang" render={renderXeTimHangPage} />
            {/* <PrivateRoute  path="/ho-so-tai-xe" render={renderDriverInfoPage} /> */}
            <PrivateRoute path="/chanh" render={renderChanhPage} />
            <PrivateRoute path="/chanh-dat-hang" render={renderChanhDatHangPage} />
            <PrivateRoute path="/hop-dong" render={renderReceiptPage} />
            <PrivateRoute path="/ke-toan-chung-tu" render={renderKeToanChungTuPage} />
            <PrivateRoute path="/bao-hiem" render={renderInsurancePage} />
            <PrivateRoute path="/bao-hiem-sap-het-han" render={renderInsuranceNearingExpirationPage} />
            <PrivateRoute path="/phap-che" render={renderPhapChe} />
            <PrivateRoute path="/don-hang-bao-hiem" render={renderOwnerInsurancePage} />
            <PrivateRoute
              roles={[CONSTANTS.SYSTEM_ROLES.QUAN_TRI_HE_THONG]}
              path="/tk-web"
              render={renderAdminUserWebPage}
            />
            <PrivateRoute path="/tai-khoan-cty" render={renderCompanyBankGroupPage} />
            <PrivateRoute path="/admin-working-time" render={renderAdminWorkingTimePage} />
            <PrivateRoute path="/thong-ke" render={renderBaoCaoThongKePage} />
            <PrivateRoute path="/tk-txe" render={renderAdminUserTxePage} />
            <PrivateRoute path="/tk-ch" render={renderAdminUserChPage} />
            <PrivateRoute path="/tk-cuoc-goi" render={renderCallTrackingStatisticPage} />
            <PrivateRoute path="/working-time" render={renderWorkingTimePage} />
            <PrivateRoute path="/target-doanh-so" render={renderCaiDatTargetDoanhSoPage} />
            <PrivateRoute path="/execute-the-plan" render={renderExecuteThePlanPage} />
            <PrivateRoute path="/nganh-hang-phu-tro" render={renderNganhHangPhuTroPage} />
            <PrivateRoute path="/app-phones" render={renderAppPhonesPage} />
            <PrivateRoute path="/phan-viec-chu-hang" render={renderCustomerAssignPage} />
            <PrivateRoute path="/phan-viec-khach-hang" render={renderPhanViecKhachHangPage} />
            <PrivateRoute path="/phan-viec-tai-xe-cu" render={renderDriverAssignPage} />
            <PrivateRoute path="/phan-viec-tai-xe" render={renderPhanViecTaiXePage} />
            <PrivateRoute path="/quan-ly-nhom-chat" render={renderManageInternalChatPage} />
            <PrivateRoute path="/quan-ly-file" render={renderFiles} />
            <PrivateRoute path="/phan-viec-nhom-nganh-hang" render={renderPhanViecNhomNganhHang} />
            <PrivateRoute path="/ke-toan-chi" render={renderKeToanChi} />
            <PrivateRoute path="/tham-khao-gia" render={renderPriceQuote} />
            <PrivateRoute path="/cai-dat-phan-don" render={renderOwnerAssignment} />
            <PrivateRoute path="/ky-quy" render={renderKyQuy} />
            <PrivateRoute path="/so-du-ngan-hang" render={renderSoDuNganHangPage} />
            <PrivateRoute path="/projectone" render={renderProjectOne} />
            <PrivateRoute path="/landing-page" render={renderLandingPage} />
            <PrivateRoute path="/danh-gia-vic-ai" render={renderDanhGiaVicAIPage} />
            <PrivateRoute path="/cai-dat-khao-sat" render={renderCaiDatKhaoSatPage} />
            <PrivateRoute path="/khao-sat" render={renderKhaoSatPage} />
            <PrivateRoute path="/export-images" exact={true} render={renderExportImagesPage} />
            <PrivateRoute path="/lich-lam-viec" render={renderLichLamViecPage} />
            <PrivateRoute path="/cai-dat-phan-quyen" render={renderCaiDatPhanQuyenPage} />
            <PrivateRoute path="/xu-ly-van-ban" render={renderXuLyVanBanPage} />
            <PrivateRoute path="/system-health" render={renderSystemHealthPage} />
            <PrivateRoute path="/ai-server" render={renderAIServerPage} />
            <PrivateRoute path="/lich-bot" render={renderLichBotPage} />
            <PrivateRoute path="/van-phong" render={renderVanPhongPage} />
            <PrivateRoute path="/hang-muc-ai" render={renderHangMucAIPage} />
            <PrivateRoute path="/chong-spam-otp" render={renderChongSpamOtpPage} />
            <Route path="/support" exact={true} render={renderSupportPage} />
            <Route path="/privacy" exact={true} render={renderPrivacyPage} />
            <Route path="/admin-login" exact={true} render={renderAdminLoginPage} />
            <Route path="*" render={redirectToPageNotFound} />
          </Switch>
        </Suspense>
      </div>
      {user.isLoggedIn() && !['/support', '/privacy'].includes(location.pathname) && (
        <CheckinCheckout ignorePage="working-time" />
      )}
      {user.isLoggedIn() && !['/support', '/privacy'].includes(location.pathname) && <SelectedChat />}
    </div>
  );
}
